<template>
  <div class="content-warp">
    <h2>《浪加APP接入第三方SDK共享清单》</h2>

    <div class="sdk-entry">
      <div class="title">极光推送 - JPush SDK</div>
      <p>应用场景描述：为 APP 用户提供信息推送服务</p>
      <p>
        收集的个人信息：设备标识符(包括Android ID、Mac地址、IMEI、MEID、IMSI、Serial、ICCID、IDFA、IDFV、OpenUDID、GAID/AAID、UAID、GUID、OAID、SIM信息)、设备硬件信息(包括设备型号、设备屏幕分辨率、设备硬件制造商、设备存储空间、设备产品名称、唯一设备识别码、硬件序列号)、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、基站信息、获取IP地址、运营商信息、网络连接状态、Wifi扫描结果、SSID、BSSID、DHCP、WiFi状态信息、WiFi列表信息）、推送信息日志、应用列表信息、位置相关信息、完全的网络访问权限、当前应用信息（应用名、应用版本号）
      </p>
      <p>共享方式：SDK本机采集</p>
      <p>第三方机构名称：深圳市和讯华谷信息技术有限公司</p>
      <p>
        隐私协议连接：<a href="https://www.jiguang.cn/license/privacy" target="_blank"
          >https://www.jiguang.cn/license/privacy</a>
      </p>
    </div>

    <div class="sdk-entry">
      <div class="title">微信SDK</div>
      <p>应用场景描述：在用户使用微信登录或者分享时使用</p>
      <p>
        收集的个人信息：设备信息(包括设备型号、设备标识符（Android ID、IMEI、MEID、IMSI、Serial、ICCID、BSSID、SSID、IDFA、IDFV、OpenUDID、GAID/AAID、UAID、GUID、OAID、MAC地址、SIM信息）、电信运营商等软硬件特征信息)、WLAN接入点、设备网络信息（网络连接状态)、分享图片或内容、当前应用信息（应用名、应用版本号）
      </p>
      <p>共享方式：SDK本机采集</p>
      <p>第三方机构名称：深圳市腾讯计算机系统有限公司</p>
      <p>
        隐私协议连接：<a
          href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
          target="_blank">
          https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a>
      </p>
    </div>

    <div class="sdk-entry">
      <div class="title">MobTech SDK</div>
      <p>应用场景描述：短信认证和多平台分享</p>
      <p>
        收集的个人信息：设备信息(Android ID、IMEI、MEID、IMSI、Serial、ICCID、BSSID、SSID、IDFA、IDFV、OpenUDID、GAID/AAID、UAID、GUID、OAID、SIM信息)、Mac地址、唯一设备识别码、硬件序列号、应用列表信息、设备网络信息（网络连接状态）、位置信息、完全的网络访问权限、分享图片或内容、手机号、当前应用信息（应用名、应用版本号）
      </p>
      <p>共享方式：SDK本机采集</p>
      <p>第三方机构名称：上海游昆信息技术有限公司</p>
      <p>
        隐私协议连接：<a href="https://www.mob.com/about/policy" target="_blank"
          >https://www.mob.com/about/policy</a
        >
      </p>
    </div>

    <div class="sdk-entry">
      <div class="title">高德地图SDK</div>
      <p>应用场景描述：用户使用定位相关功能时使用</p>
      <p>
          收集的个人信息：设备标识符(包括Android ID、Mac地址、IMEI、MEID、IMSI、Serial、ICCID、IDFA、IDFV、OpenUDID、GAID/AAID、UAID、GUID、OAID、SIM信息)、设备硬件信息(包括设备型号、设备屏幕分辨率、设备硬件制造商、设备存储空间、设备产品名称、唯一设备识别码、硬件序列号)、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、基站信息、获取IP地址、运营商信息、网络连接状态、Wifi扫描结果、SSID、BSSID、DHCP、WiFi状态信息、WiFi列表信息）、推送信息日志、应用列表信息、完全的网络访问权限、位置信息（如GPS、WLAN接入点、蓝牙和基站）、设备传感器、网络信、当前应用信息（应用名、应用版本号）
      </p>
      <p>共享方式：SDK本机采集</p>
      <p>第三方机构名称：高德软件有限公司</p>
      <p>
        隐私协议连接：<a href="https://lbs.amap.com/pages/privacy/" target="_blank"
          >https://lbs.amap.com/pages/privacy/</a
        >
      </p>
      <p>备注：暂未调用</p>
    </div>
    <div class="sdk-entry">
      <div class="title">bugly SDK</div>
      <p>应用场景描述：分析和统计系统错误	用于支持各类系统错误、崩溃的场景分析</p>
      <p>
        收集的个人信息：设备信息(Android ID、IMEI、MEID、IMSI、Serial、ICCID、BSSID、SSID、IDFA、IDFV、OpenUDID、GAID/AAID、UAID、GUID、OAID、SIM信息)、网络信息（包括网络类型、基站信息、获取IP地址、运营商信息、网络连接状态、Wifi扫描结果、SSID、BSSID）设备型号、SD卡容量、MAC地址、IP地址、APP包名和版本及所属进程名、设备是否root、网络信息、Crash信息及线程堆栈
      </p>
      <p>共享方式：SDK本机采集</p>
      <p>第三方机构名称：深圳市腾讯计算机系统有限公司</p>
      <p>
        隐私协议连接：<a href="https://privacy.qq.com/" target="_blank">https://privacy.qq.com/</a>
      </p>
    </div>
    <div class="sdk-entry">
      <div class="title">微博分享SDK</div>
      <p>应用场景描述：内容分享</p>
      <p>
          收集的个人信息：设备信息(Android ID、IMEI、MEID、IMSI、Serial、ICCID、BSSID、SSID、IDFA、IDFV、OpenUDID、GAID/AAID、UAID、GUID、OAID、SIM信息)、Mac地址、唯一设备识别码、硬件序列号、应用列表信息、设备网络信息（网络连接状态）、位置信息、完全的网络访问权限、分享图片或内容、手机号、当前应用信息（应用名、应用版本号）、设备型号、WLAN接入点、分享图片或内容
      </p>
      <p>共享方式：SDK本机采集</p>
      <p>第三方机构名称：微梦公司</p>
      <p>
        隐私协议连接：<a href="https://www.weibo.com/signup/v5/privacy" target="_blank">https://www.weibo.com/signup/v5/privacy</a>
      </p>
       <p>备注：暂未调用</p>
    </div>
    <div class="sdk-entry">
      <div class="title">融云SDK</div>
      <p>应用场景描述：即使通讯聊天</p>
      <p>
       收集的个人信息：设备标识符(包括Android ID、Mac地址、IMEI、MEID、IMSI、Serial、ICCID、IDFA、IDFV、OpenUDID、GAID/AAID、UAID、GUID、OAID、SIM信息)、设备硬件信息(包括设备型号、设备屏幕分辨率、设备硬件制造商、设备存储空间、设备产品名称、唯一设备识别码、硬件序列号)、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、基站信息、获取IP地址、运营商信息、网络连接状态、Wifi扫描结果、SSID、BSSID、DHCP、WiFi状态信息、WiFi列表信息）位置信息（如GPS、WLAN接入点、蓝牙和基站）
      </p>
      <p>共享方式：SDK本机采集</p>
      <p>第三方机构名称：北京云中融信网络科技有限公司</p>
      <p>
        隐私协议连接：<a href="https://www.rongcloud.cn/privacy" target="_blank">https://www.rongcloud.cn/privacy</a>
      </p>
      <p>备注：暂未调用</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SdkList",
};
</script>

<style scoped>
.content-warp {
  border-radius: 10px;
  width: 95%;
  margin: 0 auto;
  padding: 10px 9px;
  background: #fff;
  margin-bottom: 10px;
  margin-top: 10px;
}
.sdk-entry {
  margin-bottom: 20px;
}

.title {
  font-size: 14px;
  margin: 5px 0;
}

h2 {
  font-size: 18px;
  margin-bottom: 10px;
}

p {
  font-size: 12px;
  margin: 5px 0;
}
</style>
